module.exports = __webpack_public_path__ + "images/category_lp/game_console/store_images/3@2x_5d51bee32db144fb6a10fff84ab4c981.png";